import React, { FC } from 'react';
import { IBusiness, sum } from '../utils/utils';
import BusinessEditBank from '../DetailItem/BusinessEditBank';
import CustomAccordion from '../../../common/components/CustomAccordion/CustomAccordion';
import { Grid } from '@material-ui/core';
import BusinessRemunerationItem from '../DetailItem/BusinessRemunerationItem';

interface Params {
  businessState: IBusiness;
  setBusinessState: React.Dispatch<React.SetStateAction<IBusiness>>;
  canEditBusiness: boolean;
}

const BusinessRemuneration: FC<Params> = (props) => {
  const { businessState, setBusinessState, canEditBusiness } = props;

  const amount = sum([
    businessState.clientHonorary,
    businessState.bankCommission,
  ]);

  const title =
    'Rémunérations Connectcrédit' + (amount ? ` | ${amount} €` : '');

  return (
    <CustomAccordion title={title}>
      <Grid container>
        <BusinessRemunerationItem
          mutationVariableName="clientHonorary"
          label="Honoraires - client"
          value={businessState.clientHonorary}
          editable={canEditBusiness}
          setBusinessState={setBusinessState}
          isNumber
        />
        <BusinessEditBank
          businessState={businessState}
          setBusinessState={setBusinessState}
          editable={canEditBusiness}
        />
        <BusinessRemunerationItem
          mutationVariableName="bankCommission"
          label="Commission - banque"
          value={businessState.bankCommission}
          editable={canEditBusiness}
          setBusinessState={setBusinessState}
          isNumber
        />
      </Grid>
    </CustomAccordion>
  );
};

export default BusinessRemuneration;
